const clearColorTitle = (color: string) => {
  if (color.includes('|')) {
    const arrayColorValue = color.split('|')
    if (arrayColorValue[0].trim().includes('#')) {
      return arrayColorValue[1].trim()
    } else {
      return arrayColorValue[0].trim()
    }
  }
  if (color.includes('#')) {
    return undefined
  } else {
    return color
  }
}

export default clearColorTitle
